import { Component, OnInit, inject } from '@angular/core';
import { EnvironmentService } from '../../services/environment.service';
import { UtilityToolbarComponent } from '../../shared-components/utility-toolbar/utility-toolbar.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-download-page',
  templateUrl: './download-page.component.html',
  styleUrls: ['./download-page.component.scss'],
  imports: [UtilityToolbarComponent, MatIconModule],
})
export class DownloadPageComponent implements OnInit {
  private envSvc = inject(EnvironmentService);

  private environment;
  baseUrl: string;

  ngOnInit(): void {
    this.environment = this.envSvc.get();
    this.baseUrl =
      this.environment.env !== 'prod'
        ? `https://ra-${this.environment.env}.rightbridge.net/downloads/`
        : `https://ra.rightbridge.net/downloads/`;
  }
}
